<template>
	<div>
		<v-chip :color="color" v-for="{ title, country, url } in items" :key="title" :outlined="outlined" label class="ma-2" @click='url ? openLink(url) : ""'>
			<v-avatar left size="20" >
				<!-- <span style="font-size: 20px !important"> -->
					<flag :iso="country" />
				<!-- </span> -->
			</v-avatar>
			{{ title }}
		</v-chip>
	</div>
</template>

<script>
export default {
	name: 'CountryChips',
	props: ['color', 'items', 'outlined'],
	methods: {
		openLink(url) {
			window.open(url, '_blank')
		}
	}
}
</script>

// <style lang="stylus" scoped>
// .v-chip .v-avatar
// 	width: 16px !important
// 	height: 16px !important
// 	min-width: 16px !important
</style>